import apiRequest from "../../../apiRequest";
import { endPoints } from "../../../apis";

/**
 * GET /service-area/all
 */
export const fetchServiceAreas = async (params = {}) => {
  // console.log(params);
  return apiRequest.get(endPoints.GET_SERVICE_AREAS, { params });
};



/**
 * GET /ServiceArea/:id
 */
export const fetchServiceAreaById = async (id, params = {}) => {
  return apiRequest.get(
    endPoints.GET_SINGLE_SERVICE_AREA.replace(":id", id),
    { params }
  );
};

/**
 * POST /ServiceArea/create
 */
export const createServiceArea = async (data) => {
  return apiRequest.post(endPoints.CREATE_SERVICE_AREA, data);
};

/**
 * PUT /ServiceArea/:id
 */
export const updateServiceArea = async (id, data) => {
  return apiRequest.put(endPoints.UPDATE_SERVICE_AREA.replace(":id", id), {
    id,
    ...data,
  });
};


/**
 * PATCH /ServiceArea/:id/status
 */
export const updateServiceAreaStatus = async (id, status) => {
  // console.log(id, status)
  return apiRequest.put(
    endPoints.UPDATE_SERVICE_AREA_STATUS.replace(":id", id),
    { status }
  );
};


/**
 * DELETE /ServiceArea/:id
 */
export const deleteServiceArea = async (id) => {
  return apiRequest.delete(
    endPoints.DELETE_SERVICE_AREA.replace(":id", id)
  );
};
